import store from '../store';
import Request from './request'
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';

async function fetch(data){
    return Request("get","api/order-material-analyze/order-freight",data)
}

// 导出
async function exports(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/order-material-analyze/order-freight-export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

export default {
    fetch,
    exports,
}